module.exports = __webpack_public_path__ + "montserrat-thin-webfont.97aba2ea9d2e56140808.woff";


//////////////////
// WEBPACK FOOTER
// D:/Honda/Trunk/WizdomWebApp/Wizdom-Web-App/src/assets/fonts/montserrat-thin-webfont.woff
// module id = ../../../../../src/assets/fonts/montserrat-thin-webfont.woff
// module chunks = styles